/**
 * Archivo: ColegialesServicios.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este fichero contiene las funciones para interactuar con la API de colegiales. 
 * Incluye funciones para listar, añadir, actualizar, eliminar y gestionar favoritos de colegiales.
 * 
 * Propósito:
 * Proveer funciones para gestionar los datos de los colegiales, incluyendo su interacción con la base de datos a través del backend.
 */
const API = process.env.REACT_APP_API_BASE_URL; 

//Función para mostrar los colegiales
export const listaColegiales = async (token, permisos) => {
  const urlColegiales = `${API}/api/colegiales`;
  
  //console.log("Entra listar con: ", token, permisos)

  // Realizar la solicitud fetch solo si el token y los permisos están definidos
  if (token && permisos) {
    try {
      const response = await fetch(urlColegiales, {
          method: 'GET', 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
      });

      const data = await response.json()
      //console.log("Respuesta de la API: ", data);
      if (data.message === 'OK') {
          return { success: true, data: data.body };
      } else {
          console.log('Error al mostrar colegiales: ' + data.errors);
          return { success: false, message: data.errors };
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
    }
  }
}

// Función para añadir un colegial a favoritos
export const addFavorito = async (token, idColegial) => {
  const urlFavoritos = `${API}/api/favoritos`;

  try {
    const response = await fetch(urlFavoritos, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ id_colegial: idColegial }),
    });

    const data = await response.json();
    if (data.message === 'OK') {
      return { success: true, data: data.body };
    } else {
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('Error al enviar la solicitud:', error);
    return { success: false, message: 'Error al enviar la solicitud' };
  }
};

// Función para eliminar un colegial de favoritos
export const removeFavorito = async (token, idColegial) => {
  const urlFavoritos = `${API}/api/favoritos`;

  try {
    const response = await fetch(urlFavoritos, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ id_colegial: idColegial }),
    });

    const data = await response.json();
    if (data.message === 'OK') {
      return { success: true };
    } else {
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('Error al enviar la solicitud:', error);
    return { success: false, message: 'Error al enviar la solicitud' };
  }
};

//Función para actualizar los datos de un colegial
export const actualizarColegial = async (token, formData) => {
  const urlColegial = `${API}/api/colegial`;

  console.log("Actualizando colegial con datos y foto:", formData);
  for (let pair of formData.entries()) {
    console.log(pair[0]+ ': ' + pair[1]);
  }

  console.log("Dastos del formData" + [...formData.entries()]);


  try {
    const response = await fetch(urlColegial, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });
    

    const data = await response.json();
    if (data.message === 'OK') {
      return { success: true, data: data.body };
    } else {
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('Error al enviar la solicitud:', error);
    return { success: false, message: 'Error al enviar la solicitud' };
  }
};

//Funcioón para eliminar un colegial
export const eliminarColegial = async (token, idColegial) => {
  const urlColegial = `${API}/api/colegial`;


  try {
    const response = await fetch(urlColegial, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ id_colegial: idColegial }),
    });

    const data = await response.json();
    if (data.message === 'OK') {
      return { success: true, data: data.body };
    } else {
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('Error al enviar la solicitud:', error);
    return { success: false, message: 'Error al enviar la solicitud' };
  }
};

// Función para añadir un colegial con foto
export const añadirColegial = async (token, formData) => {
  const urlAddColegial = `${API}/api/colegial/add`;

  // console.log("Añadiendo colegial con datos y foto:", formData);
  // for (let pair of formData.entries()) {
  //   console.log(pair[0]+ ': ' + pair[1]);
  // }

  try {
      const response = await fetch(urlAddColegial, {
          method: 'POST',
          headers: {
              'Authorization': `Bearer ${token}`,
          },
          body: formData,
      });

      const data = await response.json();
      //console.log("Respuesta de la API:", data);
      if (data.success) {
          return { success: true, data: data.data };
      } else {
          return { success: false, message: data.message };
      }
  } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
  }
};

// Función para añadir colegiales desde un archivo
export const añadirColegialesDesdeArchivo = async (token, colegiales) => {
  const url = `${API}/api/colegiales/add`;

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(colegiales)
      });

      const data = await response.json();
      if (data.success) {
          return { success: true };
      } else {
          return { success: false, message: data.message };
      }
  } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
  }
};



